import { useLingui } from '@lingui/react/macro';

export const SCOPE_KEYS = [
  'scopeOrganization',
  'scopeStore',
  'scopeWorkshop',
  'scopeAfterSales',
] as const;

type ScopeKey = (typeof SCOPE_KEYS)[number];

export type { ScopeKey };

export const ROLE_LIST_SCOPE_KEYS = ['organization', 'store', 'workshop', 'after_sales'] as const;

export type RoleListScopeKey = (typeof ROLE_LIST_SCOPE_KEYS)[number];

export const useRoleScopeLabels = (): Record<ScopeKey, string> => {
  const { t } = useLingui();

  return {
    scopeOrganization: t({
      id: 'settings.roles.scope.organization',
      message: 'Organization',
    }),
    scopeStore: t({
      id: 'settings.roles.scope.store',
      message: 'Store',
    }),
    scopeWorkshop: t({
      id: 'settings.roles.scope.workshop',
      message: 'Workshop',
    }),
    scopeAfterSales: t({
      id: 'settings.roles.scope.after_sales',
      message: 'After-sales',
    }),
  };
};

export const useRoleListScopeLabels = (): Record<RoleListScopeKey, string> => {
  const cellLabels = useRoleScopeLabels();

  return {
    organization: cellLabels.scopeOrganization,
    store: cellLabels.scopeStore,
    workshop: cellLabels.scopeWorkshop,
    after_sales: cellLabels.scopeAfterSales,
  };
};
